import React, { useEffect, useState } from 'react';

import { getSubAbas } from './subabas';
import BarraSubAbas from '../../../components/BarraSubAbas';
import ContainerConteudo from '../../../components/ContainerConteudo';
import Tabela from '../../../components/Tabela';
import { getAllLogsAcessos } from '../../../services/logs/logsAcessosService';
import { formatDate } from '../../../utils/functions';

const MeusDadosAcessos: React.FC = () => {
  const [data, setData] = useState<any[]>([]);

  // Define cabeçalhos da tabela
  const headers = [
    { text: '', width: 2, key: '' },
    { text: 'ID', width: 2, key: 'id' },
    { text: 'Data/Hora', width: 10, key: 'dataAcesso' },
    { text: 'Usuário', width: 40, key: 'nomeCompleto' },
  ];

  // Função para buscar dados
  useEffect(() => {
    const fetchData = async () => {
      try {
        const logsAcessoData = await getAllLogsAcessos();
        setData(logsAcessoData);
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };
    fetchData();
  }, []);

  // Dados da tabela
  const tableData = data.map((item) => ({
    ID: item.id,
    'Data/Hora': formatDate(item.dataAcesso),
    Usuário: item.nomeCompleto,
  }));

  // Dados do Offcanvas (se necessário)
  const offCanvasData = tableData;

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <Tabela
          headers={headers}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          rowClickable={false}
        />
      </ContainerConteudo>
    </>
  );
};

export default MeusDadosAcessos;
